// https://date-fns.org/docs/format
import format from 'date-fns/format'
import isValid from 'date-fns/isValid'
import setHours from 'date-fns/setHours'
import setMinutes from 'date-fns/setMinutes'
import isBefore from 'date-fns/isBefore'
import getHours from 'date-fns/getHours'
import getMinutes from 'date-fns/getMinutes'
import isMatch from 'date-fns/isMatch'
import { add, endOfDay, startOfDay, sub } from 'date-fns'
import {
  DATE_FORMAT,
  DATE_TIME_FORMAT,
  MONTH_TIME_FORMAT,
} from '@utils/constant'

export default function formatDate(date, type = 'yyyy-MM-dd') {
  if (!checkIsValidDate(date)) {
    return date
  }
  if (date instanceof Date) {
    return format(date, type)
  }
  return format(new Date(date), type)
}
/**
 * check date is valid
 * @param {*} date string or date
 */
export function checkIsValidDate(date) {
  if (date instanceof Date) {
    return isValid(date)
  }
  return isValid(new Date(date))
}

export function checkDateFormat(value, format) {
  if (!(value instanceof Date)) {
    if (!checkIsValidDate(value)) {
      return false
    }
    let length = 10
    let dateformat = DATE_FORMAT
    if (format === 'datetime') {
      length = 16
      dateformat = DATE_TIME_FORMAT
    } else if (format === 'month') {
      length = 7
      dateformat = MONTH_TIME_FORMAT
    } else if (format === 'date' || format === '') {
      length = 10
      dateformat = DATE_FORMAT
    }
    const date = new Date(value)
    return value.length === length && value === formatDate(date, dateformat)
  }
  return true
}

export function setHourAndMinute(date, hours, minutes) {
  if (!checkIsValidDate(date)) {
    return
  }
  if (date instanceof Date) {
    date = new Date(date)
  }
  return setHours(setMinute(date, minutes), hours)
}

export function setHour(date, hours) {
  if (!checkIsValidDate(date)) {
    return
  }
  if (date instanceof Date) {
    return setHours(date, hours)
  }
  return setHours(new Date(date), hours)
}

export function setMinute(date, minutes) {
  if (!checkIsValidDate(date)) {
    return
  }
  if (date instanceof Date) {
    return setMinutes(date, minutes)
  }
  return setMinutes(new Date(date), minutes)
}

export function checkDateRanger(startDate, endDate) {
  startDate = startOfDay(new Date(startDate))
  endDate = endOfDay(new Date(endDate))
  if (!checkIsValidDate(startDate) && !checkIsValidDate(endDate)) {
    return
  }
  return isBefore(new Date(startDate), new Date(endDate))
}

export function checkDateTimeRanger(startDate, endDate) {
  if (!checkIsValidDate(startDate) && !checkIsValidDate(endDate)) {
    return
  }
  return isBefore(new Date(startDate), new Date(endDate))
}

export function getHoursOfDate(date) {
  if (!checkIsValidDate(date)) {
    return
  }
  return getHours(new Date(date))
}

export function getMinutesOfDate(date) {
  if (!checkIsValidDate(date)) {
    return
  }
  return getMinutes(new Date(date))
}

export function matchFormat(date, type) {
  if (!checkIsValidDate(date)) {
    return
  }
  return isMatch(date, type)
}

export function addDate(date, type, step) {
  date = add(new Date(date), { [type]: step })
  return date
}

export function subDate(date, type, step) {
  date = sub(new Date(date), { [type]: step })
  return date
}
